export const EKOM_TYPES: any = {
  'nabidka': 'nabidka',
  'zadost_vz': 'zadost-vz',
  'predbezna_nabidka': 'predbezna-nabidka',
  'navrh': 'navrh',
  'zadost_sk': 'zadost-sk',
  'zadost_dns': 'zadost-dns'
}

export const EKOM_TYPES_LABEL: any = {
  [EKOM_TYPES.nabidka]: 'Nabídka',
  [EKOM_TYPES.zadost_vz]: 'Žádost o účast',
  [EKOM_TYPES.predbezna_nabidka]: 'Předběžná nabídka',
  [EKOM_TYPES.navrh]: 'Soutěžní návrh',
  [EKOM_TYPES.zadost_sk]: 'Žádost o zařazení do systému kvalifikace',
  [EKOM_TYPES.zadost_dns]: 'Žádost o účast v DNS'
}

export const EKOM_STATES_LABEL: any = {
  'vzato-zpet': 'Vzato zpět',
  'doruceno-ve-lhute': 'Doručeno ve lhůtě',
  'doruceno-po-lhute': 'Doručeno po lhůtě'
}
